export default __webpack_public_path__ + "static/painter-f4cb23f41c6c91da7b963419ab7accaf.png";